import React from "react";
import { Chip, ChipProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ApplyStatus, RecommendationStatus } from "../../types/control";

// ---- Color maps (labels live in i18n: control.status / applyStatus / direction)
export const STATUS_COLORS: Record<RecommendationStatus, ChipProps["color"]> = {
  PENDING: "warning",
  ACCEPTED: "success",
  REJECTED: "error",
  EXPIRED: "default",
};

export const APPLY_STATUS_COLORS: Record<ApplyStatus, ChipProps["color"]> = {
  NOT_APPLIED: "default",
  APPLIED: "success",
  FAILED: "error",
  MANUAL_REQUIRED: "info",
};

// INCREASE = más inversión (verde, oportunidad); DECREASE = recorte (rojo).
export const directionColor = (theme: {
  palette: { success: { main: string }; error: { main: string } };
}) => ({
  INCREASE: theme.palette.success.main,
  DECREASE: theme.palette.error.main,
});

interface StatusChipProps extends Omit<ChipProps, "color" | "label"> {
  status: RecommendationStatus;
}

export const RecommendationStatusChip: React.FC<StatusChipProps> = ({
  status,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Chip
      label={t(`control.status.${status}`)}
      color={STATUS_COLORS[status] || "default"}
      size="small"
      {...rest}
    />
  );
};

interface ApplyStatusChipProps extends Omit<ChipProps, "color" | "label"> {
  applyStatus: ApplyStatus;
}

export const ApplyStatusChip: React.FC<ApplyStatusChipProps> = ({
  applyStatus,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Chip
      label={t(`control.applyStatus.${applyStatus}`)}
      color={APPLY_STATUS_COLORS[applyStatus] || "default"}
      size="small"
      variant="outlined"
      {...rest}
    />
  );
};
